export const USER_AUTOCORRECT_COUNT = 5;
export const TEMPLATE_AUTOCORRECT_COUNT = 5;
